module.exports = __webpack_public_path__ + "img/main_kakao.187fd1f5.svg";